<template>
  <v-dialog v-model="model" width="550" persistent>
    <v-card style="border-radius: 10px">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Digital Profile</span>
        <v-btn icon size="small" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="text-body-2 mb-6 text-grey-darken-1">
          Add your audio and video introduction to grab potential employers
          attention.
        </div>

        <!-- Audio Section -->
        <div class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center" style="gap: 12px">
            <v-avatar color="grey-lighten-3" size="36">
              <v-icon color="grey-darken-2">mdi-microphone</v-icon>
            </v-avatar>
            <div class="text-body-1">Add Your Audio Introduction</div>
          </div>
          <div class="d-flex align-center" style="gap: 6px">
            <v-icon color="#3b82f6">mdi-plus</v-icon>
            <span
              class="text-primary font-weight-medium"
              @click="
                model = false;
                showModal = true;
              "
              >Add</span
            >
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Video Section -->
        <div class="d-flex align-center justify-space-between mt-4">
          <div class="d-flex align-center" style="gap: 12px">
            <v-avatar color="grey-lighten-3" size="36">
              <v-icon color="grey-darken-2">mdi-play-circle-outline</v-icon>
            </v-avatar>
            <div class="text-body-1">Add Your Video Introduction</div>
          </div>
          <div class="d-flex align-center" style="gap: 6px">
            <v-icon color="#3b82f6">mdi-plus</v-icon>
            <span
              class="text-primary font-weight-medium"
              @click="
                model = false;
                showModalForVideo = true;
              "
              >Add</span
            >
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

  <AudioModal v-model="showModal" />
  <VideoModal v-model="showModalForVideo" />
</template>

<script setup>
import AudioModal from "./AudioModal.vue";
import VideoModal from "./VideoModal.vue";
import { ref, watch } from "vue";

const showModal = ref(false);

const showModalForVideo = ref(false);

const props = defineProps({
  modelValue: Boolean,
});
const emit = defineEmits(["update:modelValue"]);

const model = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => (model.value = val)
);
watch(model, (val) => emit("update:modelValue", val));

const close = () => {
  model.value = false;
};
</script>

<style scoped>
.text-primary {
  color: #3b82f6;
  cursor: pointer;
}
</style>
